"use client";

import React, {PropsWithChildren, useState} from "react";
import {FCWithHTMLAttributes} from "../types/reactTypes";
import clsMerge from "../util/clsMerge";
import {AccordionProps} from "./Accordion";

interface AccordionGroupProps extends PropsWithChildren {
	className?: string;
	children:
		| React.ReactElement<AccordionProps>
		| Array<React.ReactElement<AccordionProps>>;
}

const defaultClassName = "flex flex-col";

// If you pass a non-accordion child to this component, it will make a bunch of console errors.
// I wanted to type check the children of this component, but nextjs makes this messy.

const AccordionGroup: FCWithHTMLAttributes<AccordionGroupProps> = ({
	className,
	children,
	...props
}) => {
	const [opened, setOpened] = useState<number | undefined>(undefined);

	const handleClickAccordion = (listId: number | undefined) => {
		if (opened === listId) {
			setOpened(undefined);
		} else {
			setOpened(listId);
		}
	};

	return (
		<div className={clsMerge(defaultClassName, className)} {...props}>
			{React.Children.map(children, (child, index) => {
				// Adds controlling props to children
				if (React.isValidElement<AccordionProps>(child)) {
					return React.cloneElement(child, {
						listId: index,
						isOpenControlled: opened === index,
						onClickHeader: handleClickAccordion,
					});
				}
			})}
		</div>
	);
};

export default AccordionGroup;
